(function () {
  'use strict';
  const OZ_TO_GRAMS = 28.349523125;

  function convertElement(element) {
    if (!element || element.nodeType !== 1) return;
    const match = String(element.textContent || '').trim().match(/^(-?\d+(?:\.\d+)?)\s*oz$/i);
    if (!match) return;
    const ounces = Number(match[1]);
    if (!Number.isFinite(ounces)) return;
    element.textContent = match[1] + ' oz / ' + Math.round(ounces * OZ_TO_GRAMS) + ' g';
  }

  function addGrams(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches('[data-sld-estimator-results] strong')) convertElement(root);
    const scope = root.querySelectorAll ? root : document;
    for (const element of scope.querySelectorAll('[data-sld-estimator-results] strong')) convertElement(element);
  }

  function start() {
    addGrams(document);
    new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          addGrams(mutation.target.parentElement);
          continue;
        }
        addGrams(mutation.target);
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) addGrams(node);
          else if (node.parentElement) addGrams(node.parentElement);
        }
      }
    }).observe(document.body, { subtree: true, childList: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
